module.exports = {
  "orderManager": {
    orderManager: "订单管理",
    tenantName: "租户名称",
    tenantNameHint: "请输入租户名称",
    tenantNameHint2: "请选择租户名称",
    orderList: "订单列表",
    contactPersonUserName: "联系人",
    contactPersonUserNameHint: "请输入联系人",
    contactPersonUserPhone: "联系方式",
    contactPersonUserPhoneHint: "请输入联系方式",
    totalOrderAmount: "订单总金额（元）",
    totalOrderAmountHint: "请输入订单总金额",
    totalOrderAmountHint2: "请输入正确的订单总金额",
    payTime: "支付日期",
    payTimeHint: "请输入支付日期",
    paySource: "支付渠道",
    paySourceHint: "请选择支付渠道",
    orderStatus: "订单状态",
    orderContent: "订单内容",
    orderContentHint: "请输入订单内容",
    addOrder: "新增订单",
    editOrder: "编辑订单",
    viewOrder: "查看订单",
    customerInfo: "客户信息",
    customerInfoHint: "请完善客户信息",
    orderInfo: "订单信息",
    orderInfoHint: "请完善订单信息",
    processOrder: "审核订单",
    processInfo: "审核信息",
    processResult: "审核结果",
    processYes: "审核通过",
    processNo: "审核不通过",
    processRemark: "审核备注",
    processRemarkHint: "请输入审核备注",
    deleteOrderHint: "删除该订单将不可恢复，确定吗？",
  },
};


// WEBPACK FOOTER //
// ./src/i18n/orderManager/en.js